import { useEffect, useState } from 'react';
import { getOpinionFilterCond } from '../services';
import { gameInfoType } from '../types/common';

const tabOrder = [
  'pc',
  'playstation 4',
  'playstation 5',
  'xbox one',
  'xbox series x/s',
  'nintendo switch',
];

export default function useConsoleDevices({
  gameInfo,
  relativeInfo,
}: {
  gameInfo: gameInfoType;
  relativeInfo?: gameInfoType;
}) {
  const [tabOptions, setTabOptions] = useState([]);
  const [deviceLoading, setDeviceLoading] = useState(false);
  const [value, setValue] = useState('');
  useEffect(() => {
    if (relativeInfo && Object.keys(relativeInfo).length === 0) {
      return;
    }
    setDeviceLoading(true);
    getOpinionFilterCond({
      ...gameInfo,
      edition_unified_id: gameInfo.edition_unified_id,
      request_type: ['lifetime_console_devices'],
      un_request_type: ['topic_trans'],
    })
      .then((data: any) => {
        const { lifetime_console_devices } = data || {};
        if (lifetime_console_devices?.length > 0) {
          const orderMap = new Map(
            tabOrder.map((item, index) => [item, index]),
          );
          lifetime_console_devices.sort((a, b) => {
            const orderA = orderMap.get(a.platform.toLocaleLowerCase());
            const orderB = orderMap.get(b.platform.toLocaleLowerCase());
            const defaultOrder = Infinity;
            return (orderA ?? defaultOrder) - (orderB ?? defaultOrder);
          });
          const options = lifetime_console_devices
            .map(({ platform }: any) => ({
              text: platform,
              value: platform,
            }))
            .filter(
              (item: any) => !item.text.toLocaleLowerCase().includes('sep'),
            );

          setTabOptions(options);
          setValue(options?.[0]?.value);
        }
      })
      .finally(() => {
        setDeviceLoading(false);
      });
  }, [gameInfo, relativeInfo]);

  return {
    tabOptions,
    deviceLoading,
    value,
    setValue,
  };
}
